<template>
    <payment-result-card
        :variant="cardVariant"
        :title="cardTitle"
        :description="cardDescription"
    >
        <template v-if="hasActions" #actions>
            <app-button
                v-if="canResumePayment"
                color="brand-blue"
                @click="resumePayment"
            >
                {{ resumeLabel }}
            </app-button>
            <app-button border color="brand-blue" @click="chooseAnotherPlan">
                Elegir otro plan
            </app-button>
        </template>
    </payment-result-card>
</template>

<script>
import platformPaymentResult from "@/mixins/platformPaymentResult";
import { mapActions, mapGetters, mapState } from "vuex";

import PaymentResultCard from "@/components/utils/PaymentResultCard.vue";

export default {
    name: "PlatformPaymentResultPage",

    components: { PaymentResultCard },

    mixins: [platformPaymentResult],

    data: () => ({
        resultSource: "onboarding"
    }),

    computed: {
        ...mapState("auth", ["needOnboardingTenant"]),
        ...mapGetters("onboarding", ["routeForStep", "completionRoute"])
    },

    methods: {
        ...mapActions("onboarding", ["getOnboardingStatus"]),
        ...mapActions("auth", ["getProfile"]),

        // El pago pudo cambiar el rol: se refresca el perfil (que aplica los
        // permisos nuevos) antes de decidir a dónde ir.
        async handlePaid() {
            try {
                await this.getProfile();
            } catch {
                // Los permisos se aplican en el próximo login.
            }
            if (this.needOnboardingTenant) {
                await this.goToOnboardingStep();
                return;
            }
            this.$toast.success("Pago confirmado");
            this.$router.replace("/app/plan");
        },

        async goToOnboardingStep() {
            try {
                const { onboardingFlow: flow } =
                    await this.getOnboardingStatus();
                const step =
                    flow.status === "completed" ? flow.nextStep : flow.step;
                const route = step ? this.routeForStep(step) : null;
                this.$router.replace(route || this.completionRoute);
            } catch {
                this.$router.replace(this.completionRoute);
            }
        },

        chooseAnotherPlan() {
            if (this.needOnboardingTenant) {
                this.$router.replace(this.routeForStep("plan"));
                return;
            }
            this.$router.replace("/app/plan");
        }
    }
};
</script>
